import React from 'react';
import { FooterSection } from '../models/footer';
import localizedRoute from '../utils/localizedRoute';
import { useTranslation } from 'react-i18next';
import StyledImage from './StyledImage';
import ChangeLangCountry from './ChangeLangCountry';
import { getLangCountry } from '../helpers/languages';
import { useRouter } from 'next/router';
import { fetchFooter } from '../fetchers/footer';
import logoWhite from '../public/img/logo-white.svg';
import FooterLinks from './FooterLinks';
import parse from 'html-react-parser';
import NewsletterForm from './NewsletterForm';

const Footer = () => {
  const { t } = useTranslation();
  const router = useRouter();
  const { lang, country } = getLangCountry(router.query);
  const footer = fetchFooter({ lang });

  return (
    <footer className="bg-black" aria-labelledby="footer-heading">
      <h2 id="footer-heading" className="sr-only">
        {t('FOOTER_HEAD')}
      </h2>
      <div className="mx-auto py-8 px-4 sm:px-6 lg:px-12">
        <div className="md:flex md:items-center md:justify-between pb-8">
          <div className="mt-6">
            <StyledImage
              src={logoWhite}
              className="w-20 filter brightness-0 invert"
              alt="logo"
            />
            <NewsletterForm />
          </div>
        </div>
        <div className="mt-2 border-t border-white border-opacity-10 " />

        <div className="pt-8 pb-8 xl:grid xl:grid-cols-5 xl:gap-8">
          <div className="grid grid-cols-2 gap-8 xl:col-span-4 md:grid-cols-4 xl:grid-cols-4 ">
            {footer.map((section: FooterSection) => {
              return (
                <div key={`key-${section.title}`} className="mt-12 md:mt-0">
                  <h3 className="text-sm font-normal text-white">
                    {section.title}
                  </h3>
                  <ul className="mt-2 space-y-1">
                    {section.items.map(item => {
                      const { link = '', title = '' } = item;
                      return (
                        <li key={title}>
                          <a
                            href={
                              link.startsWith('http')
                                ? link
                                : localizedRoute(link)
                            }
                            className="text-sm text-white opacity-40 hover:text-white font-normal"
                          >
                            {parse(title)}
                          </a>
                        </li>
                      );
                    })}
                  </ul>
                </div>
              );
            })}
          </div>
          <div className="mt-12 xl:mt-0">
            <h3 className="text-sm mb-2 font-normal text-white">
              {t('COUNTRY_SHIPPING')}
            </h3>
            <ChangeLangCountry />
          </div>
        </div>

        <FooterLinks lang={lang} country={country} />

        <div className="mt-8 border-t border-white border-opacity-10 pt-8 md:flex md:items-center md:justify-between">
          <div className="flex flex-col sm:flex-row flex-1">
            <div className="flex justify-center lg:justify-start">
              <img
                src="/img/jeep-footer-badge.svg"
                alt=""
                className="w-16 mb-2 sm:mb-0"
              />
            </div>
            <div className="opacity-40 flex text-xs font-normal text-white ml-3 items-end sm:max-w-6xl">
              Jeep, the Jeep grille and related logos, vehicle model names and
              trade dress are trademarks of FCA US LLC and used under license by
              Trerè lnnovation s.r.l. Unipersonale. &copy;
              {new Date().getFullYear()}
              &nbsp; FCA US LLC.
            </div>
          </div>
          <div className="flex flex-1 justify-center">
            <a
              href="https://www.jeep-official.it/"
              className="w-30 mt-3 lg:ml-auto cursor-pointer"
              target="_blank"
              rel="noreferrer"
            >
              <img src="/img/footer-veicle.png" alt="" />
            </a>
          </div>
        </div>

        <div className="mt-8 border-t border-white border-opacity-10 pt-8 md:flex md:items-center justify-center">
          <div className="opacity-40 flex text-xs font-normal text-white ml-3 items-end sm:max-w-6xl">
            Trerè Innovation srl Unipersonale – via Modena 18 – 46041 Asola MN
            Italy - Tel. +39 0376 718611 - CF/PI IT01661460202
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
